// extracted by mini-css-extract-plugin
export var borderRadius = "_4z-4";
export var large = "_4z-3";
export var logoContainer = "_4z-0";
export var nameLogo = "_4z-2";
export var small = "_4z-1";